import type { CSSProperties } from 'react';

export const btnPrimary: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 8,
  background: 'var(--brand)',
  color: '#fff',
  padding: '10px 16px',
  borderRadius: 'var(--r-md)',
  fontWeight: 600,
  fontSize: 13,
};

export const btnGhost: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 8,
  background: 'var(--bg-elev)',
  color: 'var(--ink-2)',
  border: '1px solid var(--line-strong)',
  padding: '9px 14px',
  borderRadius: 'var(--r-md)',
  fontWeight: 500,
  fontSize: 13,
};

export const btnIcon: CSSProperties = {
  display: 'inline-grid',
  placeItems: 'center',
  width: 28,
  height: 28,
  borderRadius: 'var(--r-sm)',
  color: 'var(--ink-3)',
  border: '1px solid var(--line)',
  background: 'var(--bg-elev)',
};

export const tableStyle: CSSProperties = { width: '100%', borderCollapse: 'collapse', fontSize: 13 };

export const thStyle: CSSProperties = {
  textAlign: 'left',
  fontSize: 11,
  fontWeight: 500,
  color: 'var(--ink-3)',
  textTransform: 'uppercase',
  letterSpacing: '0.06em',
  padding: '10px 20px 12px',
  borderTop: '1px solid var(--line)',
  background: 'var(--bg-sunken)',
  whiteSpace: 'nowrap',
};

export const tdStyle: CSSProperties = {
  padding: '14px 20px',
  fontSize: 13,
  color: 'var(--ink)',
  whiteSpace: 'nowrap',
};
